import { render, staticRenderFns } from "./ChangeSecretButtonNoInput.vue?vue&type=template&id=64527822&scoped=true&"
import script from "./ChangeSecretButtonNoInput.vue?vue&type=script&lang=js&"
export * from "./ChangeSecretButtonNoInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64527822",
  null
  
)

export default component.exports